module.exports = __webpack_public_path__ + "static/assets/e4d673f94842127dace980739b177f2d.png";